<template>
    <div class="content">
        <div class="product-info product-info--micro">
            <div class="product-info__conditions">
                <h1 class="product-info__title">Микрокредит</h1>
                <p class="product-info__description">на любые цели, погашение ежемесячно</p>
                <ul class="product-info__conditions-list">
                    <li class="product-info__condition-item"><span class="icon icon--s icon--lock-v"></span>Микрокредит без
                        залога
                    </li>
                    <li class="product-info__condition-item"><span class="icon icon--s icon--tenge-v"></span>Сумма
                        микрокредита <br/>от 100 000 до 1 000 000 тенге
                    </li>
                    <li class="product-info__condition-item"><span class="icon icon--s icon--calendar-12"></span>Срок от
                        1 до 12 месяцев
                    </li>
                </ul>
                <button v-if="isMobile" class="button button--violet"
                        v-scroll-to="{el: '.product-info__calculator', offset: -50}">Получить микрокредит
                </button>
            </div>
            <div class="product-info__calculator">
                <calculator>
                    <template slot="button">
                        <button class="button button--yellow" v-if="isMobile" v-on:click="getLoan">Оформить микрокредит
                        </button>
                        <button class="button button--violet" v-else v-on:click="getLoan">Получить микрокредит</button>
                    </template>
                </calculator>
                <modal name="calculator-error" :width="'400px'" :height="'135px'">
                    <div class="calculator-error__box">
                        <p class="calculator-error__text">Микрокредиты на любые цели скоро в Казахстане.</p>
                    </div>
                </modal>
            </div>
        </div>
        <div class="any-purpose">
            <div class="any-purpose__content">
                <template v-if="isDesktop">
                    <div class="any-purpose__content-block"
                         v-for="item in anyPurpose" :key="item.id"
                         v-bind:class="'any-purpose__content-block__'+item.name">
                        <img class="any-purpose__content-block-image" :src="item.image" alt=""/>
                        <div class="any-purpose__content-block-text" v-html="item.text"></div>
                    </div>
                </template>
                <template v-else>
                    <carousel :per-page="1" :navigationEnabled="true" :paginationActiveColor="'#93278F'"
                              :paginationColor="'#FFB700'">
                        <slide v-for="item in anyPurpose" :key="item.id">
                            <div class="any-purpose__slide">
                                <img class="any-purpose__slide-image" :src="item.image" alt=""/>
                                <p class="any-purpose__slide-description" v-html="item.text"></p>
                            </div>
                        </slide>
                    </carousel>
                </template>
            </div>
            <div class="any-purpose__description">
                <div class="any-purpose__description-title">Деньги на <br/>любые цели</div>
                <div class="any-purpose__description-text">Вся необходимая сумма – и без залога</div>
                <router-link class="any-purpose__description-link" tag="a" :to="{name: 'How_to_get'}">Узнайте, как
                    получить микрокредит
                </router-link>
            </div>
            <router-link class="any-purpose__description-link any-purpose__description-link--mobile" tag="a"
                         :to="{name: 'How_to_get'}">Узнайте, как получить микрокредит
            </router-link>
        </div>
        <why-micro :title="'Подходит ли вам Микрокредит?'"></why-micro>
        <!-- <div class="sign-contract">
            <div class="sign-contract__title">Подпишите договор не выходя из дома</div>
            <div class="sign-contract__content">
                <div class="sign-contract__block">
                    <img class="sign-contract__image" src="@/assets/svg/icons/illust_mk_1.svg" alt=""/>
                    <div class="sign-contract__text">Курьер доставит пакет документов <br/>в удобное для вас место</div>
                </div>
                <div class="sign-contract__block-text">или</div>
                <div class="sign-contract__block">
                    <img class="sign-contract__image" src="@/assets/svg/icons/illust_mk_2.svg" alt=""/>
                    <div class="sign-contract__text">Подпишите электронной подписью <br/>(ЭЦП) прямо на сайте</div>
                </div>
            </div>
        </div> -->
        <div class="how-to-get">
            <div class="how-to-get__title">Вернуть так же просто, как получить</div>
            <div class="how-to-get__content">
                <div class="how-to-get__block">
                    <img class="how-to-get__image" src="@/assets/svg/icons/icon_1_mk.svg" alt=""/>
                    <div class="how-to-get__text">С банковской карты <br/>через интернет</div>
                </div>
                <div class="how-to-get__block">
                    <img class="how-to-get__image" src="@/assets/svg/icons/icon_3_mk.svg" alt=""/>
                    <div class="how-to-get__text">Через банк в ближайшем <br/>отделении вашего банка</div>
                </div>
                <div class="how-to-get__block">
                    <img class="how-to-get__image" src="@/assets/svg/icons/icon_2_mk.svg" alt=""/>
                    <div class="how-to-get__text">В одном из 60 000 <br/>платёжных терминалов</div>
                </div>
                <div class="how-to-get__block">
                    <img class="how-to-get__image" src="@/assets/svg/icons/icon_4_mk.svg" alt=""/>
                    <div class="how-to-get__text">Через электронный кошелёк <br/>Qiwi Wallet или Касса24</div>
                </div>
            </div>
        </div>
        <div class="apply-loan">
            <div class="apply-loan__block">
                <div class="apply-loan__title">от 100 000 <br/>до 1 000 000 тенге</div>
                <div class="apply-loan__description">
                    <img class="apply-loan__description-image" src="@/assets/svg/icons/lock_v.svg" alt=""/>
                    <div class="apply-loan__description-text">Без залога</div>
                </div>
                <div class="apply-loan__button button button--violet"
                     v-scroll-to="{el: '.product-info__calculator', offset: -50}">Подать заявку
                </div>
            </div>
            <div class="apply-loan__image"></div>
        </div>
        <div>
            <condition></condition>
        </div>
    </div>
</template>

<script>
import widthMixin from "@/modules/mixins/widthMixin";
import productAdapter from '@/modules/productAdapter';

    export default {
        name: "Micro",
        mixins: [widthMixin],
        metaInfo: {
            title: 'Микро – микрокредит на любые цели, погашение ежемесячно',
            meta: [
                {name: 'description', content: 'Микрокредит без залога. Сумма микрокредита от 100 000 до 1 000 000 тенге. Срок от 1 до 12 месяцев. Деньги на любые цели. Не выходя из дома. Вся сумма в одном месте. Минимальные требования'}
            ],
        },
        data() {
            return {
                name: '',
                phone: '',
                showThanks: false,
                product: '',
                anyPurpose: [
                    {
                        name: 'vacation',
                        image: require('@/assets/svg/icons/illust_1_mk.svg'),
                        text: 'Отпуск'
                    },
                    {
                        name: 'education',
                        image: require('@/assets/svg/icons/illust_3_mk.svg'),
                        text: 'Образование'
                    },
                    {
                        name: 'furniture',
                        image: require('@/assets/svg/icons/illust_5_mk.svg'),
                        text: 'Покупка мебели'
                    },
                    {
                        name: 'refinancing',
                        image: require('@/assets/svg/icons/illust_4_mk.svg'),
                        text: 'Рефинансирование'
                    },
                    {
                        name: 'repairs',
                        image: require('@/assets/svg/icons/illust_2_mk.svg'),
                        text: 'Ремонт квартиры'
                    },
                    {
                        name: 'wedding',
                        image: require('@/assets/svg/icons/illust_7_mk.svg'),
                        text: 'Свадьба'
                    },
                    {
                        name: 'purchase',
                        image: require('@/assets/svg/icons/illust_6_mk.svg'),
                        text: 'Покупка <br/>бытовой техники'
                    },
                ]
            }
        },
        methods: {
            getLoan: function () {
                this.$modal.show('calculator-error');
                // _this.$http.get('/scheduleAndGESV', {
                //     params: {
                //         term: _this.$store.getters['calculator/getField']('term'),
                //         amount: _this.$store.getters['calculator/getField']('amount'),
                //         productId: _this.$store.getters['calculator/getField']('productID'),
                //         calculationType: _this.$store.getters['calculator/getField']('creditType')
                //     }
                // }).then(
                //     response => {
                //         if (response.data.code === 0) {
                //             if (!response.data.data.exceeds) {
                //                 _this.$router.push({name: 'RegistrationStep'});
                //             } else {
                //                 _this.$modal.show('gesv-error');
                //             }
                //         }
                //     },
                //     response => {
                //     }
                // )
            }
        },
        computed: {
            Complete() {
                return this.name.length > 3 && this.phone.length === 17;
            },
        },
        mounted() {
            let _this = this;
            this.$http.get('/json/product').then(
                response => {
                    if (response.data.code === 0) {
                        let product = productAdapter.getActiveProduct(response.data.data.available, "MicroProductEngine");
                        this.$store.commit('calculator/updateField', {path: 'productID', value: product.id});
                        _this.product = productAdapter.transformProduct(product);
                    }
                },
                response => {
                }
            );
        }
    };
</script>
<style lang="scss">
    @import "~@/assets/scss/variable";
    @import "~@/assets/scss/site/desktop/product/product-info";
    @import "~@/assets/scss/site/desktop/product/lead-form";
    @import "~@/assets/scss/site/desktop/product/thanks";
    @import "~@/assets/scss/site/mobile/product/product-info";
    @import "~@/assets/scss/site/mobile/product/lead-form";
    @import "~@/assets/scss/site/mobile/product/thanks";

    .calculator-error {
        &__box {
            padding: 15px;
            display: flex;
            align-items: center;
            height: 100%;
        }
        &__text {
            text-align: center;
            color: #666666;
            font-family: $Montserrat;
            font-size: 24px;
            font-weight: 600;
            text-align: center;
            color: $purple-site;
        }
    }

    .any-purpose {
        display: inline-flex;
        flex-flow: row wrap;
        align-items: center;
        justify-content: space-between;

        max-width: 1024px;
        width: 100%;
        margin-bottom: 70px;
        padding: 0 20px;
        &__content {
            display: inline-flex;
            flex-flow: row wrap;
            align-items: flex-start;
            justify-content: flex-start;

            width: 550px;
        }
        &__content-block {

            &__vacation {
                margin: 0 44px 34px 67px;
                animation: levitate+random(7) 3s infinite ease-in-out;
                will-change: transform;
                .any-purpose__content-block-image {
                    width: 78px;
                    height: 75px;
                }
            }
            &__education {
                margin: 16px 55px 26px 0;
                animation: levitate+random(7) 3s infinite ease-in-out;
                will-change: transform;
                .any-purpose__content-block-image {
                    width: 165px;
                    height: 165px;
                }
            }
            &__furniture {
                margin: 93px 0 40px 0;
                animation: levitate+random(7) 3s infinite ease-in-out;
                will-change: transform;
                .any-purpose__content-block-image {
                    width: 120px;
                    height: 117px;
                }
            }
            &__refinancing {
                margin: -140px 52px 16px 0;
                animation: levitate+random(7) 3s infinite ease-in-out;
                will-change: transform;
                .any-purpose__content-block-image {
                    width: 126px;
                    height: 114px;
                }
            }
            &__repairs {
                margin: -44px 59px 0 0;
                animation: levitate+random(7) 3s infinite ease-in-out;
                will-change: transform;
                .any-purpose__content-block-image {
                    width: 99px;
                    height: 100px;
                }
            }
            &__wedding {
                animation: levitate+random(7) 3s infinite ease-in-out;
                will-change: transform;
                .any-purpose__content-block-image {
                    width: 70px;
                    height: 73px;
                }
            }
            &__purchase {
                margin: -70px 0 0 49px;
                animation: levitate+random(7) 3s infinite ease-in-out;
                will-change: transform;
                .any-purpose__content-block-image {
                    width: 84px;
                    height: 80px;
                }
            }
        }
        &__content-block-image {
        }
        &__content-block-text {
        }
        &__description {
            display: inline-flex;
            flex-flow: column wrap;
            align-items: flex-start;
            justify-content: flex-start;
        }
        &__description-title {
            margin-bottom: 20px;
            text-align: left;
            color: $yellow-1;
            font-family: $MontserratBold;
            font-size: 36px;
        }
        &__description-text {
            margin-bottom: 63px;
            text-align: left;
            color: $gray-dim-dark;
            font-family: $Montserrat;
            font-size: 18px;
        }
        &__description-link {
            margin-bottom: 63px;
            text-align: left;
            color: $tooltip_background_blue;
            font-family: $RobotoRegular;
            font-size: 18px;

            &--mobile {
                display: none
            }
        }
    }

    .sign-contract {
        width: 100%;
        background: #F7F7F7;
        padding: 46px 0 56px;

        &__title {
            text-align: center;
            color: $gray-dim-dark;
            font-family: $MontserratBold;
            font-size: 30px;
        }
        &__text {
            text-align: center;
            color: $gray-dim-dark;
            font-family: $MontserratMedium;
            font-size: 16px;
        }
        &__content {
            display: inline-flex;
            flex-flow: row wrap;
            align-items: flex-start;
            justify-content: space-between;

            width: 100%;
            max-width: 900px;
            margin: 65px auto 0;
            padding: 0 70px;
        }
        &__image {
            width: 100%;
            height: 230px;
            background: $white;
            border-radius: 25px;
            margin-bottom: 31px;
            padding: 25px 0;
        }
        &__block {
            width: 45%;
        }
        &__block-text {
            display: inline-flex;
            align-items: center;
            height: 230px;

            text-align: center;
            color: $gray-dim-dark;
            font-family: $MontserratMedium;
            font-size: 16px;
        }
    }

    .how-to-get {
        width: 100%;
        padding: 53px 0;

        &__title {
            text-align: center;
            color: $purple-site-dark;
            font-family: $MontserratMedium;
            font-weight: 600;
            font-size: 30px;
        }
        &__text {
            text-align: left;
            color: $gray-dim-dark;
            font-family: $MontserratMedium;
            font-size: 16px;
        }
        &__content {
            display: inline-flex;
            flex-flow: row wrap;
            align-items: flex-start;
            justify-content: space-between;

            width: 100%;
            max-width: 900px;
            margin: 80px auto 0;
            padding: 0 45px;
        }
        &__image {
            min-width: 84px;
            max-width: 84px;
            max-height: 72px;
            margin-right: 20px;
        }
        &__block {
            display: inline-flex;
            flex-flow: row wrap;
            align-items: center;
            justify-content: flex-start;

            width: 45%;
            margin-bottom: 48px;
        }
    }

    .apply-loan {
        display: inline-flex;
        flex-flow: row wrap;
        align-items: flex-end;
        justify-content: center;

        width: 95%;
        max-width: 1024px;
        height: 250px;
        margin: 30px 0 64px;

        background: $yellow-site;
        border-radius: 12px;
        &__block {
            display: inline-flex;
            flex-flow: column wrap;
            align-items: flex-start;
            justify-content: space-between;

            height: 100%;
            padding: 33px 30px 24px;
        }
        &__title {
            text-align: left;
            color: $gray-dim-dark;
            font-family: $RobotoBold;
            font-size: 24px;
        }
        &__description {
            display: inline-flex;
            flex-flow: row wrap;
            align-items: center;
            justify-content: flex-start;
        }
        &__description-image {
            width: 27px;
            height: 40px;
            margin-right: 13px;
        }
        &__description-text {
            text-align: left;
            color: $gray-dim-dark;
            font-family: $RobotoRegular;
            font-size: 18px;
        }
        &__button {
            width: 100%;
            margin-left: -15px;
        }
        &__image {
            width: 388px;
            height: 279px;
            background: url("~@/assets/img/micro/banner_mk.png") center / contain no-repeat;
        }
    }

    @media screen and (max-width: 1024px) {
        .any-purpose {
            flex-flow: column;
            justify-content: center;

            &__content {
                order: 2;
                margin-bottom: 50px;
            }
            &__description {
                order: 1;
                align-items: center;
            }
            &__description-title {
                br {
                    display: none;
                }
            }
            &__description-text {
                margin-bottom: 30px;
                font-family: $MontserratMedium;
            }
            &__description-link {
                display: none;
                &--mobile {
                    order: 3;
                    display: inline-block;
                    margin: 0;
                }
            }
            &__slide {
                background: $white;
                margin: 15px 60px 15px;
                padding: 30px 85px;
                border-radius: 15px;
                height: 400px;
                box-shadow: 0 2px 13px 0 rgba(208, 208, 208, 1);
                text-align: center;
            }
            &__slide-description {
                margin-top: 20px;
                color: $gray-dim-dark;
                font-size: 26px;
                font-family: $RobotoBold;
            }
            .VueCarousel {
                width: 100%;
            }
        }
        .sign-contract {
            padding: 46px 30px 56px;
            &__content {
                max-width: unset;
                padding: 0;
            }
        }
        .how-to-get {
            padding: 53px 30px 0;
            &__content {
                max-width: unset;
                padding: 0;
            }
            &__block {
                width: 50%;
            }
        }
    }

    @media screen and (max-width: 768px) {
        .any-purpose {
            &__content {
                width: 480px;
            }
            &__description-title {
                text-align: center;
            }
            &__description-text {
                text-align: center;
            }
            &__slide {
                display: inline-flex;
                align-items: center;
                flex-flow: column nowrap;
                justify-content: center;

                width: 70%;
                height: 330px;
                margin: 15px auto;
                padding: 30px 10px;
            }
        }
        .sign-contract {
            background: $white;
            &__content {
                flex-flow: column wrap;
                align-items: center;
            }
            &__block {
                width: 100%;
            }
            &__block-text {
                height: 80px;
            }
        }
        .how-to-get {
            background: #F7F7F7;
            &__content {
                flex-flow: column wrap;
                align-items: center;
            }
            &__block {
                width: 360px;
            }
        }
        .apply-loan {
            align-items: flex-start;
            justify-content: flex-start;
            overflow: hidden;
            background: $yellow-site url("~@/assets/img/micro/mk_mob_banner.png") 50vw 10px / 295px 325px no-repeat;
            &__block {
                margin-left: 7vw;
                padding: 33px 20px 24px;
            }
            &__image {
                display: none;
            }
        }
    }

    @media screen and (max-width: 500px) {
        .any-purpose {
            padding: 0 10px;
            &__content {
                width: 100%;
            }
            &__slide {
                width: 75%;
            }
            &__slide-description {
                font-size: 22px;
            }
        }
        .sign-contract {
            padding: 46px 10px 56px;
            &__content {
                margin: 40px auto 0;
            }
            &__title {
                font-size: 26px;
            }
            &__text {
                font-size: 14px;
            }
            &__image {
                margin-bottom: 15px;
            }
        }
        .how-to-get {
            padding: 53px 10px 0;
            &__content {
                margin: 40px auto 0;
            }
            &__title {
                font-size: 26px;
            }
            &__text {
                font-size: 14px;
            }
            &__block {
                width: 300px;
            }
            &__image {
                min-width: 64px;
                max-width: 64px;
                max-height: 52px;
                margin-right: 10px;
            }
        }
        .apply-loan {
            background: $yellow-site url("~@/assets/img/micro/mk_mob_banner.png") 50vw 70px / 185px 215px no-repeat;
            &__block {
                margin-left: 0;
                padding: 20px;
                justify-content: flex-start;
            }
            &__image {
                display: none;
            }
            &__button {
                margin: 0;
                padding: 6px;
            }
            &__title {
                font-size: 20px;
            }
            &__description {
                margin: 10px 0;
            }
            &__description-image {
                width: 27px;
                height: 30px;
                margin-right: 5px;
            }
            &__description-text {
                font-size: 16px;
            }
        }
    }

    @media screen and (max-width: 320px) {
        .any-purpose {
            margin-bottom: 30px;
            &__content {
                margin-bottom: 20px;
            }
            &__slide-description {
                font-size: 20px;
            }
        }
        .sign-contract {
            padding: 30px 10px 30px;
            &__title {
                font-size: 22px;
            }
            &__content {
                margin: 20px auto 0;
            }
            &__image {
                height: 200px;
            }
            &__block-text {
                height: 50px;
            }
        }
        .how-to-get {
            padding: 30px 10px 0;
            &__title {
                font-size: 22px;
            }
            &__image {
                min-width: 52px;
                max-width: 52px;
                max-height: 40px;
                margin-right: 6px;
            }
            &__block {
                width: 100%;
                margin-bottom: 30px;
            }
            &__content {
                margin: 30px auto 0;
            }
        }
    }

    @for $i from 1 through 8 {
        @keyframes levitate#{$i} {
            0% {
                transform: translateY(0px);
            }
            50% {
                transform: translateY(- (random(14) + 4) + px);
            }
            100% {
                transform: translateY(0px);
            }
        }
    }
</style>
